<template>
    <div class="project">

        <el-menu theme="dark" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                 @select="handleSelect" router>

            <el-menu-item index="/home/arrange/arrange">排班列表</el-menu-item>
            <!-- <el-menu-item index="/home/arrange/conventionList">预约详情</el-menu-item> -->

        </el-menu>

        <router-view></router-view>
    </div>
</template>
<script>

  export default {
    name: 'project',
    data() {
      return {
        msg: '项目',
        activeIndex: '1',
        handleSelect(key, keyPath) {
        }
      }
    }
  }
</script>

<style scoped>

</style>
<script>

  export default {
    name: 'project',
    data() {
      return {
        msg: '项目',
        activeIndex: '/home/arrange/arrange',
        handleSelect(key, keyPath) {
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// arrange_menu.vue?66d3c4de